import type { ExternalTableSchema } from '@packages/table-builder';

export const emailTemplatesTable: ExternalTableSchema = {
  metadata: {
    title: 'Email Templates',
    entity: 'EmailTemplate',
    description: 'Email template list.',
  },

  dataSource: {
    endpoint: '/api/notification/api/app/notification-template',
    method: 'GET',
    rowIdField: 'id',
    responseMapping: {
      items: 'items',
      totalCount: 'totalCount',
    },
    requestParams: {
      Filter: 'table.searchText',
      MaxResultCount: 'table.pageSize',
      SkipCount: 'table.pageOffset',
      Sorting: 'table.sorting',
      IsActive: 'filters.isActive',
      NotificationMediumIds: 'filters.notificationMediumIds',
      NotificationCategories: 'filters.notificationCategories',
      RecipientTypes: 'filters.recipientTypes',
    },
    filters: [
      {
        name: 'isActive',
        placeholder: 'Status',
        type: 'select',
        options: [
          { label: 'Active', value: 'true' },
          { label: 'Inactive', value: 'false' },
        ],
      },
      {
        name: 'notificationMediumIds',
        placeholder: 'Delivery Type',
        type: 'asyncSelect',
        dataSource: {
          url: '/api/notification/api/app/notification-medium',
          labelField: 'displayName',
          valueField: 'id',
        },
      },
      {
        name: 'notificationCategories',
        placeholder: 'Functional Area',
        type: 'asyncSelect',
        dataSource: {
          url: '/api/notification/api/app/notification-category',
          labelField: 'name',
          valueField: 'name',
        },
      },
      {
        name: 'recipientTypes',
        placeholder: 'Recipient Type',
        type: 'asyncSelect',
        dataSource: {
          url: '/api/notification/api/app/recipient-type',
          labelField: 'name',
          valueField: 'name',
        },
      },
    ],
  },

  columns: [
    {
      field: 'notificationType',
      header: 'Notification Type',
      type: 'modal',
      width: 350,
      align: 'left',
      modal: {
        presentation: 'compose-popover',
        composeActionId: 'BUILD_EMAIL_TEMPLATE_POPOVER_VIEW',
        composeMeta: {
          mode: 'view',
          entity: 'EmailTemplate',
          semanticId: 'emailTemplatePopoverView',
        },
        panelClassName: 'roles-popovers email-template-popover',
      },
      fields: { id: 'id' },
    },
    {
      field: 'notificationMedium',
      header: 'Notification Medium',
      type: 'text',
      align: 'left',
    },
    {
      field: 'notificationCategory',
      header: 'Notification Category',
      type: 'text',
      align: 'left',
      visibility: 'picker',
    },
    {
      field: 'recipientType',
      header: 'Recipient Type',
      type: 'text',
      width: 200,
      align: 'left',
    },
    {
      field: 'isActive',
      header: 'Status',
      type: 'badge',
      align: 'center',
      badge: {
        statusMap: { true: 'success', false: 'error' },
        displayMap: { true: 'Active', false: 'Inactive' },
        defaultVariant: 'info',
      },
      conditionalValues: { true: 'Active', false: 'Inactive' },
    },
    {
      field: 'creationTime',
      header: 'Created Date',
      type: 'date',
      width: 180,
      align: 'center',
    },
  ],

  actions: {
    row: [{ id: 'EDIT_EMAIL_TEMPLATE', label: 'Edit' }],
    bulk: [{ id: 'EXPORT_BULK_EMAIL_TEMPLATE', label: 'Bulk Export' }],
    toolbar: {
      secondary: [
        {
          label: 'Import',
          icon: 'upload',
          type: 'upload',
          children: [{ id: 'IMPORT_EMAIL_TEMPLATE', label: 'Import Bulk XLS' }],
        },
      ],
    },
  },

  features: {
    search: { enabled: true },
    pagination: { mode: 'infiniteScroll', defaultSize: 1000 },
    selection: { keyField: 'id' },
    columnPreferences: {
      persistenceKey: 'Email Template',
      resizable: true,
      reorderable: true,
    },
  },
};
